"use client"

import { useState } from "react"
import { ChevronDown } from "lucide-react"

import { cn } from "@/utils/utils"
import { FAQ_ITEMS } from "./faq-data"

export function Faq() {
  const [open, setOpen] = useState(0)

  return (
    <div>
      {FAQ_ITEMS.map((item, i) => {
        const isOpen = open === i
        return (
          <div key={item.q} className="border-b border-border">
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              className="font-heading flex w-full items-center justify-between gap-4 py-5.5 text-left text-[17px] font-semibold"
            >
              <span>{item.q}</span>
              <ChevronDown
                className={cn("size-5.5 flex-none text-primary transition-transform duration-200", isOpen && "rotate-180")}
              />
            </button>
            {isOpen && (
              <p className="animate-accordion-down max-w-[46rem] pr-8 pb-5.5 text-[15px] leading-relaxed text-muted-foreground">
                {item.a}
              </p>
            )}
          </div>
        )
      })}
    </div>
  )
}
